<template>
    <div class="flex flex-wrap gap-2">
        <button
            v-for="(option, index) in options"
            :key="index"
            type="button"
            class="border-zinc-700 bg-card flex min-w-32 flex-1 items-center gap-3 border p-3 font-bold transition-colors"
            @click="toggleOption(option.value)"
        >
            <div
                class="flex h-4 w-4 items-center justify-center border-zinc-700"
                :class="isSelected(option.value) ? 'bg-red-500' : 'border bg-zinc-900'"
            >
                <svg
                    v-if="isSelected(option.value)"
                    class="w-2.5"
                    viewBox="0 0 9 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.94271 0.942708L3.13802 6.7474L0 3.60938L0.942708 2.66667L3.13802 4.86198L8 0L8.94271 0.942708Z"
                        fill="white"
                    />
                </svg>
            </div>
            {{ option.label }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'Checkboxes',
    props: {
        // Array of the selected option values.
        modelValue: {
            type: Array,
            default: () => [],
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        settings: {
            type: Object,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    methods: {
        isSelected(value) {
            return this.modelValue.includes(value)
        },
        toggleOption(value) {
            const next = this.isSelected(value)
                ? this.modelValue.filter((selected) => selected !== value)
                : [...this.modelValue, value]
            this.$emit('update:modelValue', next)
        },
    },
}
</script>
